var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlankPurpleCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8184 2.04936H13.0912V0.727051H11.6366V2.04936H4.3639V0.727051H2.90936V2.04936H2.18208C1.38208 2.04936 0.727539 2.64441 0.727539 3.37168V13.9502C0.727539 14.6775 1.38208 15.2725 2.18208 15.2725H13.8184C14.6184 15.2725 15.273 14.6775 15.273 13.9502V3.37168C15.273 2.64441 14.6184 2.04936 13.8184 2.04936ZM13.8184 13.9502H2.18208V5.35515H13.8184V13.9502Z",
    fill: "#8464C5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlankPurpleCalendar);
export default __webpack_public_path__ + "static/media/blank-purple-calendar.c81df488de09185951bd129f8854e3ec.svg";
export { ForwardRef as ReactComponent };